import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_f_info_circle_dark_blue.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_announce.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-21dfefd2")

_pushScopeId("data-v-21dfefd2")
const _hoisted_1 = {
  "data-testid": "booking-v4-receiver-section",
  class: "w-full"
}
const _hoisted_2 = { class: "flex flex-col gap-y-3" }
const _hoisted_3 = { class: "flex flex-row items-center justify-between pb-1" }
const _hoisted_4 = { class: "flex flex-row gap-2 items-center" }
const _hoisted_5 = {
  key: 0,
  class: "px-2 py-0.5 bg-blue-lp-600 justify-center items-center gap-3 inline-flex truncate rounded"
}
const _hoisted_6 = {
  key: 0,
  class: "text-gray-lp-800 text-xs truncate"
}
const _hoisted_7 = { class: "text-gray-lp-800 text-xs truncate" }
const _hoisted_8 = { class: "flex flex-col gap-y-3" }
const _hoisted_9 = { class: "flex items-center gap-x-2 w-full" }
const _hoisted_10 = { class: "text-14px font-medium text-gray-lp-300 col-span-3 text-left" }
const _hoisted_11 = { class: "flex flex-col gap-1 w-full mt-2" }
const _hoisted_12 = { class: "flex items-center font-semibold gap-x-2" }
const _hoisted_13 = { class: "col-span-2 flex items-center gap-x-1.5" }
const _hoisted_14 = { class: "text-xs text-black-lp-100 font-normal ml-1.5" }
const _hoisted_15 = { class: "flex flex-col w-full" }
const _hoisted_16 = { class: "flex items-start gap-4" }
const _hoisted_17 = {
  key: 0,
  role: "status",
  "data-testid": "booking-v4-receiver-district-misbooking-guidance",
  class: "flex flex-row items-start rounded-lg bg-blue-lp-600 text-blue-lp-700 text-xs px-2.5 py-1 space-x-2 mt-2 border border-blue-lp-1100"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "info blue",
  class: "mt-px"
}, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1"
}
const _hoisted_20 = {
  key: 2,
  "data-testid": "booking-v4-package-weight-one-piece-restriction",
  class: "flex flex-col mt-2 w-full"
}
const _hoisted_21 = { class: "flex flex-row px-4 py-1 rounded-lg bg-blue-lp-600 items-center w-full" }
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "mr-2",
  alt: "announce",
  style: {"height":"24px","width":"24px"}
}, null, -1)
const _hoisted_23 = { class: "text-blue-lp-700 text-sm" }
const _hoisted_24 = {
  key: 3,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1 flex flex-row space-x-4"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "info red"
}, null, -1)
const _hoisted_26 = {
  key: 4,
  class: "text-red-lp-100 text-12px xxl:text-14px mt-1 flex flex-row space-x-4"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "info red"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectCustomer = _resolveComponent("SelectCustomer")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_LpInput = _resolveComponent("LpInput")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Title, {
            label: _ctx.$t('bookingV4.detailRecipient'),
            fontSize: 16,
            bold: "bold",
            fontColor: "text-black-lp-100"
          }, null, 8, ["label"])
        ]),
        (_ctx.allowPaste)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              (_ctx.isAutofillProcessing)
                ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("bookingV4.recipient.autofill.processing")), 1))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("bookingV4.autofill")), 1),
                    _createVNode("button", {
                      type: "button",
                      "data-testid": "booking-v4-receiver-autofill-button",
                      class: ["text-12px xxl:text-14px font-bold underline", [
                _ctx.disabledPasteAutofill
                  ? 'text-gray-lp-600 cursor-not-allowed'
                  : 'text-blue-lp-300'
              ]],
                      disabled: _ctx.disabledPasteAutofill,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onAutofillFromClipboard && _ctx.onAutofillFromClipboard(...args)))
                    }, _toDisplayString(_ctx.$t("bookingV4.paste")), 11, ["disabled"])
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        (_ctx.isInternational)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: _ctx.$t('bookingV4.recipient.country.label'),
              class: "col-span-2 w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectSearch, {
                  id: "booking-v4-receiver-country-dropdown",
                  "data-testid": "booking-v4-receiver-country-dropdown",
                  class: "mt-2",
                  serverSide: false,
                  keyName: "label",
                  keyValue: "code",
                  options: _ctx.countryListFiltered,
                  placeholder: _ctx.$t('bookingV4.recipient.country.placeholder'),
                  "model-value": _ctx.selectedCountry,
                  errorMessage: _ctx.$t('bookingV4.recipient.country.error.notFound'),
                  isShowErrorIndicator: !!_ctx.errorMessageCountry,
                  errorCaption: _ctx.errorMessageCountry,
                  isDisabled: _ctx.disabledDestinationCountry || _ctx.isDisableReceiver,
                  disabledBackground: 
              _ctx.disabledDestinationCountry || _ctx.isDisableReceiver
            ,
                  onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.receiverCountryIndex))),
                  onBlur: _ctx.onValidateCountry,
                  "onUpdate:modelValue": _ctx.onChangeDestinationCountry
                }, {
                  "selected-prefix": _withId(({ selected }) => [
                    (selected?.flag)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          class: "self-center w-4 mr-2",
                          alt: selected.name,
                          src: selected.flag
                        }, null, 8, ["alt", "src"]))
                      : _createCommentVNode("", true)
                  ]),
                  "custom-option": _withId(({ item }) => [
                    _createVNode("button", _hoisted_9, [
                      (item?.flag)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "self-center w-4",
                            alt: item.name,
                            src: item.flag
                          }, null, 8, ["alt", "src"]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_10, _toDisplayString(item.label), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["options", "placeholder", "model-value", "errorMessage", "isShowErrorIndicator", "errorCaption", "isDisabled", "disabledBackground", "onBlur", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.configName.rule !== _ctx.configValidationForm.NON_SHOW)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 1,
              label: _ctx.$t('bookingV4.name'),
              class: "w-full"
            }, {
              default: _withId(() => [
                _createVNode(_component_SelectCustomer, {
                  id: "booking-v4-receiver-name-input",
                  "data-testid": "booking-v4-receiver-name-input",
                  column: "Penerima",
                  placeholder: "bookingV4.recipient.name.placeholder",
                  customerName: _ctx.modelValue.receiver.name,
                  "onUpdate:customerName": [
                    _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.receiver.name = $event)),
                    _ctx.onChangeName
                  ],
                  loading: _ctx.loadingCustomerList,
                  options: _ctx.customerList,
                  keyName: "customerPhoneNumber",
                  error: !!_ctx.errorMessageName,
                  errorCaption: _ctx.errorMessageName,
                  onFocus: _cache[4] || (_cache[4] = ($event: any) => (
              _ctx.onFocusCustomer(_ctx.receiverNameIndex, _ctx.modelValue.receiver.name)
            )),
                  onBlur: _ctx.onValidateName,
                  onSelect: _ctx.onSelectCustomer,
                  class: "mt-2",
                  useInfiniteScroll: "",
                  onScrolled: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onScroll(_ctx.modelValue.receiver.name))),
                  disabled: _ctx.disabledName || _ctx.isDisableReceiver
                }, null, 8, ["customerName", "onUpdate:customerName", "loading", "options", "error", "errorCaption", "onBlur", "onSelect", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.configPhone.rule !== _ctx.configValidationForm.NON_SHOW)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 2,
              label: _ctx.$t('bookingV4.phoneNumber')
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_SelectPhoneCountry, {
                    id: "booking-v4-receiver-phone-input",
                    "data-testid": "booking-v4-receiver-phone-input",
                    column: "Penerima",
                    keyName: "customerName",
                    code: _ctx.modelValue.receiver.phoneCode,
                    "onUpdate:code": [
                      _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.receiver.phoneCode = $event)),
                      _ctx.onChangePhone
                    ],
                    phone: _ctx.modelValue.receiver.phone,
                    "onUpdate:phone": [
                      _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.receiver.phone = $event)),
                      _ctx.onChangePhone
                    ],
                    error: _ctx.errorMessagePhone,
                    isLoading: _ctx.loadingCustomerList,
                    options: _ctx.customerList,
                    onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onFocusCustomer(_ctx.receiverPhoneIndex, _ctx.fullPhoneNumber))),
                    onBlur: _ctx.onValidatePhone,
                    onSelect: _ctx.onSelectCustomer,
                    useInfiniteScroll: "",
                    onScrolled: _cache[9] || (_cache[9] = () => _ctx.onScroll(_ctx.fullPhoneNumber)),
                    bookingVersion: "v4",
                    disabled: _ctx.disabledPhone || _ctx.isDisableReceiver
                  }, null, 8, ["code", "onUpdate:code", "phone", "onUpdate:phone", "error", "isLoading", "options", "onBlur", "onSelect", "disabled"])
                ])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.configAddress.rule !== _ctx.configValidationForm.NON_SHOW)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 3,
              label: _ctx.$t('bookingV4.address'),
              class: "col-span-2 w-full"
            }, {
              label: _withId(() => [
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV4.address")), 1),
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_Toggle, {
                      id: "booking-v4-receiver-office-flag-toggle",
                      "data-testid": "booking-v4-receiver-office-flag-toggle",
                      modelValue: _ctx.isOfficeFlag,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.isOfficeFlag = $event)),
                      height: "14px",
                      width: "25px",
                      knobSize: "10px",
                      customLabel: "",
                      disabled: _ctx.disabledAddress
                    }, {
                      "custom-label": _withId(() => [
                        _createVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("bookingV4.office")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ])
                ])
              ]),
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  id: "booking-v4-receiver-address-input",
                  "data-testid": "booking-v4-receiver-address-input",
                  type: "textarea",
                  preventEnterTextArea: "",
                  showMaxLength: "",
                  textAreaRows: "3",
                  modelValue: _ctx.modelValue.receiver.address,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.modelValue.receiver.address = $event)),
                  error: !!_ctx.errorMessageAddress,
                  "error-caption": _ctx.errorMessageAddress,
                  format: _ctx.replaceNewLine,
                  placeholder: "bookingV4.recipient.address.placeholder",
                  maxLength: _ctx.maxAddressLength,
                  disabled: _ctx.disabledAddress || _ctx.isDisableReceiver,
                  disableBackground: _ctx.disabledAddress,
                  onFocus: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.receiverAddressIndex))),
                  onBlur: _ctx.onValidateAddress,
                  onChange: _ctx.onValidateAddress,
                  pbTextAreaWithLength: "pb-10",
                  sizeInput: "12px xxl:text-14px"
                }, null, 8, ["modelValue", "error", "error-caption", "format", "maxLength", "disabled", "disableBackground", "onBlur", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            (_ctx.isDistrictFirst)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  (_ctx.configDistrict.rule !== _ctx.configValidationForm.NON_SHOW)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 0,
                        label: _ctx.districtFieldLabel,
                        class: "w-2/3"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_SelectSearch, {
                            id: "booking-v4-receiver-district-dropdown",
                            "data-testid": "booking-v4-receiver-district-dropdown",
                            class: "mt-2",
                            onFilter: _ctx.fetchDestinationCity,
                            useInfiniteScroll: "",
                            onScrolled: _ctx.onScrollDistrict,
                            isLoading: _ctx.isLoadingDestinationCity,
                            options: _ctx.destinationCityList,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: _ctx.districtFieldPlaceholder,
                            modelValue: _ctx.modelValue.receiver.destinationCity,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.modelValue.receiver.destinationCity = $event)),
                            errorMessage: _ctx.$t('bookingV4.recipient.city.error.notFound'),
                            isShowErrorIndicator: 
                    !!_ctx.errorMessageDestination ||
                      _ctx.isErrorEmbargo ||
                      _ctx.isErrorRouteNotFound
                  ,
                            errorCaption: _ctx.errorMessageDestination,
                            onFocus: _ctx.onFocusDestinationCity,
                            onBlur: _ctx.onValidateDestinationCity,
                            onChange: _ctx.onSelectDestinationCity,
                            onClear: _ctx.clearSearch,
                            isDisabled: _ctx.disabledDistrict || _ctx.isDisableReceiver,
                            disabledBackground: _ctx.disabledDistrict || _ctx.isDisableReceiver
                          }, null, 8, ["onFilter", "onScrolled", "isLoading", "options", "placeholder", "modelValue", "errorMessage", "isShowErrorIndicator", "errorCaption", "onFocus", "onBlur", "onChange", "onClear", "isDisabled", "disabledBackground"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.configPostalCode.rule !== _ctx.configValidationForm.NON_SHOW)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 1,
                        label: _ctx.$t('bookingV4.postalCode'),
                        class: "w-1/3"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_SelectSearch, {
                            id: "booking-v4-receiver-postal-code-dropdown",
                            "data-testid": "booking-v4-receiver-postal-code-dropdown",
                            serverSide: false,
                            placeholder: 
                    _ctx.$t('bookingV4.recipient.postalCode.placeholder')
                  ,
                            class: "mt-2",
                            keyName: "name",
                            keyValue: "name",
                            options: _ctx.postalCodeList,
                            modelValue: _ctx.modelValue.receiver.postalCode,
                            "onUpdate:modelValue": [
                              _cache[14] || (_cache[14] = ($event: any) => (_ctx.modelValue.receiver.postalCode = $event)),
                              _ctx.onChangePostalCode
                            ],
                            errorMessage: 
                    _ctx.$t('bookingV4.recipient.postalCode.error.notFound')
                  ,
                            isShowErrorIndicator: !!_ctx.errorMessagePostalCode,
                            errorCaption: _ctx.errorMessagePostalCode,
                            onFocus: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.receiverPostalCodeIndex))),
                            onBlur: _ctx.onBlurPostalCode,
                            onClear: _ctx.clearPostalCode,
                            onFilter: _ctx.onGetPostalCodeList,
                            onKeypress: _ctx.allowAlphanumeric,
                            isDisabled: _ctx.disabledPostalCode || _ctx.isDisableReceiver,
                            disabledBackground: _ctx.disabledPostalCode || _ctx.isDisableReceiver
                          }, null, 8, ["placeholder", "options", "modelValue", "errorMessage", "isShowErrorIndicator", "errorCaption", "onBlur", "onUpdate:modelValue", "onClear", "onFilter", "onKeypress", "isDisabled", "disabledBackground"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.configPostalCode.rule !== _ctx.configValidationForm.NON_SHOW)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 0,
                        label: _ctx.$t('bookingV4.postalCode'),
                        class: "w-1/3"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_SelectSearch, {
                            id: "booking-v4-receiver-postal-code-dropdown",
                            "data-testid": "booking-v4-receiver-postal-code-dropdown",
                            serverSide: false,
                            placeholder: 
                    _ctx.$t('bookingV4.recipient.postalCode.placeholder')
                  ,
                            class: "mt-2",
                            keyName: "name",
                            keyValue: "name",
                            options: _ctx.postalCodeList,
                            modelValue: _ctx.modelValue.receiver.postalCode,
                            "onUpdate:modelValue": [
                              _cache[16] || (_cache[16] = ($event: any) => (_ctx.modelValue.receiver.postalCode = $event)),
                              _ctx.onChangePostalCode
                            ],
                            errorMessage: 
                    _ctx.$t('bookingV4.recipient.postalCode.error.notFound')
                  ,
                            isShowErrorIndicator: !!_ctx.errorMessagePostalCode,
                            errorCaption: _ctx.errorMessagePostalCode,
                            onFocus: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.receiverPostalCodeIndex))),
                            onBlur: _ctx.onBlurPostalCode,
                            onClear: _ctx.clearPostalCode,
                            onFilter: _ctx.onGetPostalCodeList,
                            onKeypress: _ctx.allowAlphanumeric,
                            isDisabled: _ctx.disabledPostalCode || _ctx.isDisableReceiver,
                            disabledBackground: _ctx.disabledPostalCode || _ctx.isDisableReceiver
                          }, null, 8, ["placeholder", "options", "modelValue", "errorMessage", "isShowErrorIndicator", "errorCaption", "onBlur", "onUpdate:modelValue", "onClear", "onFilter", "onKeypress", "isDisabled", "disabledBackground"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_ctx.configDistrict.rule !== _ctx.configValidationForm.NON_SHOW)
                    ? (_openBlock(), _createBlock(_component_DataWrapper, {
                        key: 1,
                        label: _ctx.districtFieldLabel,
                        class: "w-2/3"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_SelectSearch, {
                            id: "booking-v4-receiver-district-dropdown",
                            "data-testid": "booking-v4-receiver-district-dropdown",
                            class: "mt-2",
                            onFilter: _ctx.fetchDestinationCity,
                            useInfiniteScroll: "",
                            onScrolled: _ctx.onScrollDistrict,
                            isLoading: _ctx.isLoadingDestinationCity,
                            options: _ctx.destinationCityList,
                            keyName: "name",
                            keyValue: "id",
                            placeholder: _ctx.districtFieldPlaceholder,
                            modelValue: _ctx.modelValue.receiver.destinationCity,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.modelValue.receiver.destinationCity = $event)),
                            errorMessage: _ctx.$t('bookingV4.recipient.city.error.notFound'),
                            isShowErrorIndicator: !!_ctx.errorMessageDestination,
                            errorCaption: _ctx.errorMessageDestination,
                            onFocus: _ctx.onFocusDestinationCity,
                            onBlur: _ctx.onValidateDestinationCity,
                            onChange: _ctx.onSelectDestinationCity,
                            onClear: _ctx.clearSearch,
                            isDisabled: _ctx.disabledDistrict || _ctx.isDisableReceiver,
                            disabledBackground: _ctx.disabledDistrict || _ctx.isDisableReceiver
                          }, null, 8, ["onFilter", "onScrolled", "isLoading", "options", "placeholder", "modelValue", "errorMessage", "isShowErrorIndicator", "errorCaption", "onFocus", "onBlur", "onChange", "onClear", "isDisabled", "disabledBackground"])
                        ]),
                        _: 1
                      }, 8, ["label"]))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          (_ctx.showMisbookingGuidance)
            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", null, _toDisplayString(_ctx.$t("bookingV4.recipient.city.misbookingGuidance")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.destinationCity?.status === 'INACTIVE')
            ? (_openBlock(), _createBlock("div", _hoisted_19, _toDisplayString(_ctx.$t("bookingShipment.error.inactiveCity")), 1))
            : _createCommentVNode("", true),
          (_ctx.isVendorNinjaDestination)
            ? (_openBlock(), _createBlock("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("bookingV4.goods.koli.error.districtOnePiece")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isErrorEmbargo)
            ? (_openBlock(), _createBlock("div", _hoisted_24, [
                _hoisted_25,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.embargo")), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isErrorRouteNotFound)
            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                _hoisted_27,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.error.routeNotFound")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})